import {
  REGISTER_USER,
  REGISTER_USER_SUCCESSFUL,
  REGISTER_USER_FAILED,
  REGISTER_EMAIL_VERIFIED_SUCCESS,
  REGISTER_OTP_VERIFIED_SUCCESS,
  REGISTER_CREATE_SELF_NEW_ACCOUNT_SUCCESS, REGISTER_USER_INITIAL, REGISTER_CREATE_SELF_NEW_ACCOUNT_FAIL,
} from "./actionTypes"

const initialState = {
  registrationError: null,
  message: null,
  loading: false,
  user: null,
  emailVerified: false,
  otpVerified: false,
  onBoarding: false,
  onBoardingFailed: false,
}

const account = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_USER_INITIAL:
      state = {
        ...state,
        emailVerified: false,
        otpVerified: false,
        onBoarding: false,
      }
      break
    case REGISTER_USER:
      state = {
        ...state,
        loading: true,
        registrationError: null,
      }
      break
    case REGISTER_USER_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload,
        registrationError: null,
      }
      break
    case REGISTER_USER_FAILED:
      state = {
        ...state,
        user: null,
        loading: false,
        registrationError: action.payload,
      }
      break
    case REGISTER_EMAIL_VERIFIED_SUCCESS:
      state = {
        ...state,
        emailVerified : action.payload,
      }
      break;
    case REGISTER_OTP_VERIFIED_SUCCESS:
      state = {
        ...state,
        otpVerified : action.payload,
      }
      break
    case REGISTER_CREATE_SELF_NEW_ACCOUNT_SUCCESS:
      state = {
        ...state,
        onBoarding: true,
      }
      break
    case REGISTER_CREATE_SELF_NEW_ACCOUNT_FAIL:
      state = {
        ...state,
        onBoardingFailed: action.payload,
      }
      break;
    default:
      state = { ...state }
      break
  }
  return state
}

export default account
